import styled, { css } from 'styled-components'

interface EllipseContainerProps {
  color: string
}

export const EllipseContainer = styled.div<EllipseContainerProps>`
  position: relative;
  width: 43px;
  height: 43px;
  box-shadow: 0px 4px 4px ${props => props.theme.colors.colorBlack1a};
  border: 1px solid ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 50%;
  cursor: pointer;

  * {
    pointer-events: none;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  .background {
    position: absolute;
    inset: 0;
    background: ${props => props.color};
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
  }

  &:hover .background {
    filter: brightness(0.8);
  }

  svg {
    position: relative;
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
  }
`

interface IQuantityContainer {
  color: string
  isAltered: boolean
}

const badgeAlertStyles = css`
  background: ${props => props.theme.colors.colorff0000};
  border: 1.5px solid ${props => props.theme.colors.colorf3f5f9};
  color: ${props => props.theme.colors.colorf3f5f9};
`

const badgeNormalStyles = css<IQuantityContainer>`
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  color: ${props => props.color};
`

export const EllipseBadge = styled.div<IQuantityContainer>`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(30%, -45%);
  width: 20px;
  height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  ${({ isAltered }) => (isAltered ? badgeAlertStyles : badgeNormalStyles)}

  text-align: center;
  font-weight: 700;
  font-size: 0.875rem;
  letter-spacing: 0px;
`
